import { DELIVERED, SHIPPED, PENDED } from '../utilities/constant_config';
$(function() {
  const processingFlag = $('input[name=processingFlag]').val();
  const shippingFlag = $('input[name=shippingFlag]').val();
  const orderStatus = $('input[name=orderStatus]').val();
  const button2 = $('.trackerButtons_step2 #orderTrackerProcessingIcon');
  const stepCompleteIcon =
    'svg-icon_check_white svg-icon_check_white-dims orderTrackerHoldIcon';
  const stepProcessed =
    'svg-icon_process_white svg-icon_process_white-dims svg-icon_refresh_white';

  if (processingFlag) {
    $('.trackerButtons_step2').addClass('processingStep');
    $('.trackerButtons_step3').addClass('shippingStep');
    button2.removeClass().addClass(stepProcessed);
  } else if (shippingFlag) {
    $('.trackerButtons_step2').addClass('stepComplete');
    $('.trackerButtons_step3').addClass('processingStep');
    button2.removeClass().addClass(stepCompleteIcon);
    $('.trackerButtons_step3 #orderTrackerShippedIcon').show();
    $('.shippingSpan').removeClass('shippingSpan');
    $('.trackerButtons_step3 #orderTrackerShippedIcon')
      .removeClass()
      .addClass(stepProcessed);
  } else if (orderStatus === DELIVERED || orderStatus === SHIPPED) {
    $('.trackerButtons_step2').addClass('stepComplete');
    $('.trackerButtons_step3').addClass('stepComplete');
    $('.shippingSpan').removeClass('shippingSpan');
    button2.removeClass().addClass(stepCompleteIcon);
    $('.trackerButtons_step3 #orderTrackerShippedIcon').show();
    $('.trackerButtons_step3 #orderTrackerShippedIcon')
      .removeClass()
      .addClass(stepCompleteIcon);
  } else if (orderStatus === PENDED) {
    $('.trackerButtons_step2').addClass('processingStep');
    $('.trackerButtons_step3').addClass('shippingStep');
    $('.orderTrackerHoldIcon').hide();
    $('.pcf_status').hide();
    button2.hide();
  }
});
